var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventGroupChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1297 51.8379C14.5352 51.8379 10 47.3087 10 41.7217C10 36.1347 14.5352 31.6055 20.1297 31.6055C25.7242 31.6055 30.2594 36.1347 30.2594 41.7217L30.2594 49.542C30.2594 50.81 29.2301 51.8379 27.9605 51.8379L20.1297 51.8379Z",
    fill: "#CF3642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4074 31.5C47.0019 31.5 51.5371 36.0292 51.5371 41.6162C51.5371 47.2032 47.0019 51.7324 41.4074 51.7324C35.8129 51.7324 31.2777 47.2032 31.2777 41.6162L31.2777 33.7959C31.2777 32.5279 32.307 31.5 33.5767 31.5L41.4074 31.5Z",
    fill: "#FF8300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6775 20.1162C31.6775 14.5292 36.2127 10 41.8072 10C47.4017 10 51.9369 14.5292 51.9369 20.1162C51.9369 25.7032 47.4017 30.2324 41.8072 30.2324H33.9764C32.7068 30.2324 31.6775 29.2045 31.6775 27.9365V20.1162Z",
    fill: "#3E7AFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventGroupChat);
export default __webpack_public_path__ + "static/media/event_group_chat.734f3971f79dcd7030e28b74973ef87e.svg";
export { ForwardRef as ReactComponent };